//@ts-nocheck
import { defineMessages } from 'react-intl';

export default defineMessages({
  reportIssue: 'Report an issue',
  contactSupport: 'Contact support',
  searchHelpSite: 'Search the help site',
  help: 'Help',
  signOut: 'Sign out',
  dashboard: 'Dashboard',
  globalSearch: 'Global search',
  viewTutorials: 'View tutorials',
  myProfile: 'My profile',
  myProfileAndAnalytics: 'My profile and analytics',
  welcome: 'Welcome {name}!',
  learningSiteTour: "Learning site here's a quick tour of your learning site {siteName}",
  improvedSearch: 'Introducing improved search',
  search: 'Search',
  searchTextIn: "Search for <span class='highlight'>{searchText}</span> in:",
  topResults: 'Top results',
  recentSearches: 'Recent searches',
  clear: 'Clear',
  all: 'All results',
  module: 'Modules',
  assets: 'Assets',
  series: 'Series',
  peer: 'Peers',
  file: 'Files',
  noResult: "Sorry, we couldn't find any matching results",
  gotIt: 'Got it',
  privacyPolicy: 'Privacy policy',
  compareKScore: 'Compare with peers',
  descriptionKScore: `Total knowledge score helps you measure your progress as a learner. Every 100 points you score in a module earns 1 knowledge score.`,
  yourScore: 'Total knowledge score',
  helpAndSupport: 'Help and support',
  noAccess:
    'This content belongs to a course that is not yet complete.{br} You must complete the course to access it here.',
});
